import { FC, MouseEventHandler } from 'react'

import { Title, Text, Button, Icon } from '../../components/UI'

const RegisterFormError:FC<{ onClick: MouseEventHandler<HTMLButtonElement>, message?: string}> = ({ message, onClick })  => {
  return (
    <div className="text-center pt-40 pb-50 px-15">
      <Icon name="modal-error" />
      <Title component="h4" size="20" weight="bold" className="mt-20">Ha ocurrido un error</Title>
      <Text className="mt-20">{message ? message : 'No ha sido posible completar el registro'}</Text>
      <Button className="mt-30" onClick={onClick}>REINTENTAR</Button>
    </div>
  )
}

export { RegisterFormError }